import React, { useEffect, useState } from 'react';
import api from '../services/api';

const eur = n => '€ ' + parseFloat(n||0).toLocaleString('it-IT',{minimumFractionDigits:2});

export default function MagazzinoPage() {
  const [vista, setVista]    = useState('lista');
  const [prodSel, setProd]   = useState(null);

  if (vista==='nuovo')     return <FormProdotto onBack={()=>setVista('lista')} onSaved={()=>setVista('lista')} />;
  if (vista==='modifica')  return <FormProdotto prodotto={prodSel} onBack={()=>setVista('lista')} onSaved={()=>setVista('lista')} />;
  return <ListaProdotti
    onNuovo={()=>setVista('nuovo')}
    onModifica={p=>{setProd(p);setVista('modifica');}}
  />;
}

// ── LISTA ──────────────────────────────────────────────────────
function ListaProdotti({ onNuovo, onModifica }) {
  const [prodotti, setProdotti] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [q, setQ]               = useState('');
  const [pagina, setPagina]     = useState(1);
  const [totPagine, setTotPag]  = useState(1);
  const [cercando, setCercando] = useState(false);

  const carica = async (p=1, query='') => {
    setLoading(true);
    try {
      const url = query ? `/fic/prodotti?q=${encodeURIComponent(query)}&page=${p}` : `/fic/prodotti?page=${p}`;
      const res = await api.get(url);
      setProdotti(res.data?.data || []);
      setTotPag(res.data?.last_page || 1);
      setPagina(p);
    } catch(e) { console.error(e); }
    finally { setLoading(false); setCercando(false); }
  };

  useEffect(() => { carica(1); }, []);

  const handleSearch = (val) => {
    setQ(val);
    setCercando(true);
    clearTimeout(window._searchTimer);
    window._searchTimer = setTimeout(() => carica(1, val), 400);
  };

  const elimina = async (prod) => {
    if (!window.confirm(`Eliminare "${prod.name}" da FIC?`)) return;
    try {
      await api.delete(`/fic/prodotto/${prod.id}`);
      carica(pagina, q);
    } catch(e) { alert(e.response?.data?.error || 'Errore.'); }
  };

  const stockBadge = (prod) => {
    const curr = prod.stock_current ?? null;
    const min  = prod.stock_minimum ?? 0;
    if (curr === null) return <span style={{color:'#9ca3af',fontSize:12}}>—</span>;
    if (curr <= 0)     return <span className="badge badge-red">⚠️ Esaurito</span>;
    if (min > 0 && curr <= min) return <span className="badge badge-orange">⚠️ {curr}</span>;
    return <span className="badge badge-green">✅ {curr}</span>;
  };

  return (
    <div className="page-content">
      <div style={{display:'flex',gap:12,marginBottom:16,flexWrap:'wrap'}}>
        <div style={{position:'relative',flex:1,maxWidth:320}}>
          <input className="form-control"
            placeholder="🔍 Cerca prodotto o codice..."
            value={q} onChange={e=>handleSearch(e.target.value)} />
          {cercando && <span style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',fontSize:12,color:'#9ca3af'}}>...</span>}
        </div>
        <button className="btn btn-primary" onClick={onNuovo}>➕ Nuovo prodotto</button>
        <span style={{marginLeft:'auto',alignSelf:'center',color:'#9ca3af',fontSize:13}}>
          {prodotti.length} prodotti · pag. {pagina}/{totPagine}
        </span>
      </div>

      {loading ? <div className="loading"><div className="spinner"></div></div> : (
        <div className="card" style={{padding:0}}>
          <div className="table-wrap">
            <table className="q-table">
              <thead><tr>
                <th>Codice</th><th>Nome</th><th>Categoria</th>
                <th style={{textAlign:'right'}}>Prezzo netto</th>
                <th style={{textAlign:'right'}}>Prezzo lordo</th>
                <th style={{textAlign:'right'}}>Costo medio</th>
                <th style={{textAlign:'center'}}>Giacenza</th>
                <th style={{textAlign:'center'}}>Soglia min.</th>
                <th></th>
              </tr></thead>
              <tbody>
                {prodotti.length===0 && (
                  <tr><td colSpan={7} style={{textAlign:'center',color:'#9ca3af',padding:32}}>
                    Nessun prodotto trovato
                  </td></tr>
                )}
                {prodotti.map(p => (
                  <tr key={p.id}>
                    <td style={{fontSize:12,color:'#6b7280',fontFamily:'monospace'}}>{p.code||'—'}</td>
                    <td><strong>{p.name}</strong>
                      {p.description && <div style={{fontSize:11,color:'#9ca3af'}}>{p.description.substring(0,50)}</div>}
                    </td>
                    <td style={{fontSize:12,color:'#6b7280'}}>{p.category?.name||'—'}</td>
                    <td style={{textAlign:'right'}}>{eur(p.net_price)}</td>
                    <td style={{textAlign:'right'}}>{eur(p.gross_price)}</td>
                    <td style={{textAlign:'right',fontSize:12,color:'#6b7280'}}>{eur(p.average_cost||0)}</td>
                    <td style={{textAlign:'center'}}>{stockBadge(p)}</td>
                    <td style={{textAlign:'center',fontSize:12,color:'#9ca3af'}}>{p.stock_minimum ?? '—'}</td>
                    <td style={{display:'flex',gap:4}}>
                      <button className="btn btn-secondary btn-sm" onClick={()=>onModifica(p)}>✏️</button>
                      <button className="btn btn-danger btn-sm" onClick={()=>elimina(p)}>🗑</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {totPagine>1 && (
        <div style={{display:'flex',gap:8,marginTop:12,justifyContent:'center'}}>
          <button className="btn btn-secondary btn-sm" disabled={pagina<=1} onClick={()=>carica(pagina-1,q)}>⬅</button>
          <span style={{alignSelf:'center',fontSize:13}}>{pagina}/{totPagine}</span>
          <button className="btn btn-secondary btn-sm" disabled={pagina>=totPagine} onClick={()=>carica(pagina+1,q)}>➡</button>
        </div>
      )}
    </div>
  );
}

// ── FORM CREA/MODIFICA ─────────────────────────────────────────
function FormProdotto({ prodotto, onBack, onSaved }) {
  const isEdit = !!prodotto;
  const [form, setForm] = useState({
    name:         prodotto?.name         || '',
    code:         prodotto?.code         || '',
    description:  prodotto?.description  || '',
    net_price:    prodotto?.net_price    || 0,
    vat_value:    prodotto?.vat?.value   ?? 22,
    stock_current:prodotto?.stock_current ?? 0,
    stock_min:    prodotto?.stock_minimum ?? 0,
  });
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState('');

  const setF = (k, v) => setForm(f => ({...f, [k]: v}));

  const lordo = parseFloat(form.net_price||0) * (1 + parseFloat(form.vat_value||22)/100);

  const salva = async () => {
    if (!form.name.trim()) { setError('Nome obbligatorio.'); return; }
    setSaving(true); setError('');
    try {
      const payload = {
        name:         form.name,
        code:         form.code  || null,
        description:  form.description || null,
        net_price:    parseFloat(form.net_price||0),
        vat_value:    parseFloat(form.vat_value||22),
        stock_current:parseFloat(form.stock_current||0),
        stock_min:    parseFloat(form.stock_min||0),
      };
      if (isEdit) {
        await api.put(`/fic/prodotto/${prodotto.id}`, payload);
      } else {
        await api.post('/fic/prodotti', payload);
      }
      onSaved();
    } catch(e) {
      setError(e.response?.data?.error || 'Errore nel salvataggio .');
    } finally { setSaving(false); }
  };

  return (
    <div className="page-content">
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16}}>
        <button className="btn btn-secondary" onClick={onBack}>⬅ Indietro</button>
        <h2 style={{margin:0}}>{isEdit ? `✏️ Modifica: ${prodotto.name}` : '➕ Nuovo prodotto'}</h2>
      </div>

      {error && <div className="error-msg" style={{marginBottom:16}}>{error}</div>}

      <div style={{maxWidth:600}}>

        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:12}}>📋 Dati prodotto</div>
          <div style={{display:'grid',gap:12}}>
            <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:12}}>
              <div className="form-group" style={{margin:0}}>
                <label className="form-label">Nome *</label>
                <input className="form-control" value={form.name}
                  onChange={e=>setF('name',e.target.value)} placeholder="Nome prodotto..." />
              </div>
              <div className="form-group" style={{margin:0}}>
                <label className="form-label">Codice</label>
                <input className="form-control" value={form.code}
                  onChange={e=>setF('code',e.target.value)} placeholder="SKU, codice..." />
              </div>
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Descrizione</label>
              <textarea className="form-control" rows={2} value={form.description}
                onChange={e=>setF('description',e.target.value)}
                placeholder="Descrizione prodotto..." />
            </div>
          </div>
        </div>

        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:12}}>💰 Prezzi</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12}}>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Prezzo netto (€)</label>
              <input type="number" className="form-control" value={form.net_price} min={0} step={0.01}
                onChange={e=>setF('net_price',e.target.value)} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">IVA %</label>
              <select className="form-control" value={form.vat_value}
                onChange={e=>setF('vat_value',e.target.value)}>
                <option value={0}>0%</option>
                <option value={4}>4%</option>
                <option value={10}>10%</option>
                <option value={22}>22%</option>
              </select>
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Prezzo lordo (€)</label>
              <input type="number" className="form-control" value={lordo.toFixed(2)} readOnly
                style={{background:'#f9fafb',color:'#6b7280'}} />
            </div>
          </div>
        </div>

        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:12}}>📦 Giacenze FIC</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Quantità in stock</label>
              <input type="number" className="form-control" value={form.stock_current} min={0} step={0.01}
                onChange={e=>setF('stock_current',e.target.value)} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Soglia minima ⚠️</label>
              <input type="number" className="form-control" value={form.stock_min} min={0} step={0.01}
                onChange={e=>setF('stock_min',e.target.value)}
                placeholder="Alert sotto questa quantità" />
            </div>
          </div>
          {parseFloat(form.stock_current||0) > 0 && parseFloat(form.stock_current||0) <= parseFloat(form.stock_min||0) && (
            <div style={{marginTop:8,padding:'8px 12px',background:'#fff7ed',border:'1px solid #fed7aa',borderRadius:6,fontSize:12,color:'#92400e'}}>
              ⚠️ Stock sotto la soglia minima!
            </div>
          )}
        </div>

        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-primary" onClick={salva} disabled={saving}>
            {saving ? 'Salvataggio...' : `💾 ${isEdit?'Aggiorna':'Crea'} `}
          </button>
          <button className="btn btn-secondary" onClick={onBack}>Annulla</button>
        </div>
      </div>
    </div>
  );
}
